<div class="min-h-screen bg-gray-50 dark:bg-gray-900">
  <div class="px-2 py-4">
    <section class="desempenho-mobile-panel px-3 pt-3 pb-1 mb-1">
      <!--
      <div *ngIf="turma" class="desempenho-context-box rounded-lg border border-amber-300/80 bg-amber-50/70 dark:bg-amber-900/10 dark:border-amber-700/60 px-3 py-2 mb-3">
        <div class="text-[11px] font-semibold text-amber-900 dark:text-amber-200 truncate">{{ turma.descricao || 'Turma selecionada' }}</div>
        <div class="mt-1 space-y-0.5 text-[10px] text-amber-800 dark:text-amber-300/90">
          <div *ngIf="itemEducacional" class="truncate">{{ itemEducacional.descricao }}</div>
          <div *ngIf="periodo" class="truncate">{{ periodoAtualLabel }}</div>
        </div>
      </div>
      -->

      <div *ngIf="!semCalendario && !isSemPeriodoAvaliativo" class="mb-3 flex flex-row items-center gap-2">
        <div class="min-w-0 basis-[42%]">
          <app-page-title title="Desempenho"></app-page-title>
          <!--
          <div *ngIf="exibeSituacaoPeriodo" class="mt-2 inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-medium"
            [ngClass]="isPeriodoEncerrado(periodo!) ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-200' : 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-200'">
            {{ situacaoPeriodoAtualLabel }}
          </div>
          -->
        </div>

        <div class="min-w-0 basis-[58%]">
          <app-periodo-select
            [options]="periodoOptions"
            [selectedId]="periodoSelecionadoId"
            [emptyLabel]="'Período'"
            [dropdownWidthClass]="'w-full min-w-[16rem]'"
            (optionSelected)="onPeriodoOptionSelected($event)">
          </app-periodo-select>
        </div>
      </div>

      <ng-container *ngIf="!semCalendario && !isSemPeriodoAvaliativo">
      <div class="relative mb-3" data-dropdown-root>
        <button
          type="button"
          id="visualizarDropdown"
          class="desempenho-mobile-select w-full rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 py-2.5 text-left shadow-sm"
          (click)="toggleVisualizarDropdown()">
          <div class="flex items-center justify-between gap-2">
            <div class="min-w-0 text-center flex-1">
              <div class="text-[10px] uppercase tracking-[0.08em] text-gray-500 dark:text-gray-400">Visualizando por</div>
              <div class="truncate text-xs font-medium text-gray-800 dark:text-gray-100">{{ porInstrumento && !isTurmaEjaModular ? 'Instrumentos de avaliação' : 'Resultados de avaliações anuais' }}</div>
            </div>
            <lucide-icon name="chevron-down" class="w-4 h-4 shrink-0 text-gray-500 dark:text-gray-300"></lucide-icon>
          </div>
        </button>

        <div *ngIf="showVisualizarDropdown" class="absolute right-0 mt-1 w-full rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg z-40 overflow-hidden">
          <button type="button" (click)="openPorInstrumento(); closeDropdowns()" class="flex w-full items-center justify-between gap-3 px-4 py-3 text-left text-sm transition-colors"
            [ngClass]="porInstrumento && !isTurmaEjaModular ? 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-200 font-medium' : 'text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700'">
            <span>Por instrumentos de avaliação</span>
            <lucide-icon *ngIf="porInstrumento && !isTurmaEjaModular" name="check" class="w-4 h-4 shrink-0"></lucide-icon>
          </button>
          <button type="button" (click)="openPorAno(); closeDropdowns()" class="flex w-full items-center justify-between gap-3 px-4 py-3 text-left text-sm transition-colors"
            [ngClass]="!porInstrumento || isTurmaEjaModular ? 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-200 font-medium' : 'text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700'">
            <span>Por resultados de avaliações anuais</span>
            <lucide-icon *ngIf="!porInstrumento || isTurmaEjaModular" name="check" class="w-4 h-4 shrink-0"></lucide-icon>
          </button>
        </div>
      </div>

      <section *ngIf="porInstrumento && !isTurmaEjaModular" class="mb-3 px-1">
        <button
          type="button"
          (click)="openCadInstrumentoAvaliacao()"
          class="inline-flex h-[2.65rem] items-center gap-2 rounded-md bg-[#3f79d8] px-4 text-white transition-all duration-200 hover:bg-[#356fcc]"
        >
          <lucide-icon name="plus" class="w-4 h-4"></lucide-icon>
          <span class="text-sm font-medium">Instrumento</span>
        </button>
      </section>

      <div *ngIf="!isTurmaEjaModular && itensEducacionais.length > 0" class="desempenho-mobile-nav mb-2">
        <button
          type="button"
          (click)="prevItensEducacionais()"
          [disabled]="disabledPrev"
          class="desempenho-mobile-nav__arrow"
          title="Disciplina anterior">
          <lucide-icon name="chevron-left" class="w-4 h-4"></lucide-icon>
        </button>

        <div class="relative min-w-0 flex-1" data-dropdown-root>
          <button
            type="button"
            class="desempenho-mobile-nav__center"
            (click)="toggleDisciplinaDropdown()"
            id="disciplinaDropdown"
            [title]="itemEducacional?.descricao || 'Selecione um componente curricular'">
            <span class="desempenho-mobile-nav__dot" [style.background]="getDisciplinaCorPorIndex(getDisciplinaIndexSelecionada())"></span>
            <span class="truncate">{{ limitText(itemEducacional?.descricao || (labelItensEducacionais | titlecase), 36) }}</span>
            <lucide-icon name="chevron-down" class="w-4 h-4 shrink-0"></lucide-icon>
          </button>

          <ul class="absolute left-0 right-0 mt-1 bg-white dark:bg-gray-800 rounded shadow-lg border border-gray-200 dark:border-gray-700 max-h-60 overflow-y-auto z-50"
            [class.hidden]="!showDisciplinaDropdown"
            aria-labelledby="disciplinaDropdown">
            <li *ngFor="let item of itensEducacionais; let i = index; trackBy: trackByItemEducacional">
              <a
                href
                (click)="changeItemEducacional(item); closeDropdowns(); $event.preventDefault()"
                class="flex items-center gap-2 px-3 py-2 text-sm transition-colors cursor-pointer"
                [class.bg-blue-600]="itemEducacional?.id === item.id"
                [class.text-white]="itemEducacional?.id === item.id"
                [class.font-semibold]="itemEducacional?.id === item.id"
                [class.text-gray-700]="itemEducacional?.id !== item.id"
                [class.dark:text-gray-200]="itemEducacional?.id !== item.id"
                [class.hover:bg-blue-50]="itemEducacional?.id !== item.id"
                [class.dark:hover:bg-gray-700]="itemEducacional?.id !== item.id">
                <span class="desempenho-mobile-nav__dot shrink-0" [style.background]="getDisciplinaCorPorIndex(i)"></span>
                <span class="flex-1 truncate text-left">{{ item.descricao }}</span>
                <lucide-icon *ngIf="itemEducacional?.id === item.id" name="check" class="w-4 h-4 shrink-0 ml-auto"></lucide-icon>
              </a>
            </li>
          </ul>
        </div>

        <button
          type="button"
          (click)="nextItensEducacionais()"
          [disabled]="disabledNext"
          class="desempenho-mobile-nav__arrow"
          title="Próxima disciplina">
          <lucide-icon name="chevron-right" class="w-4 h-4"></lucide-icon>
        </button>
      </div>

      <div *ngIf="porInstrumento && !isTurmaEjaModular && instrumentosAvaliacaoParaSelecao.length" class="desempenho-mobile-nav mb-2">
        <button
          type="button"
          (click)="selecionarInstrumentoAnterior()"
          [disabled]="!podeSelecionarInstrumentoAnterior"
          class="desempenho-mobile-nav__arrow"
          title="Instrumento anterior">
          <lucide-icon name="chevron-left" class="w-4 h-4"></lucide-icon>
        </button>

        <div class="relative min-w-0 flex-1" data-dropdown-root>
          <button
            type="button"
            class="desempenho-mobile-nav__center"
            (click)="toggleInstrumentoDropdown()"
            id="instrumentoDropdown"
            [title]="instrumentoVisualizadoResumo?.descricao || 'Selecione um instrumento de avaliação'">
            <span class="truncate">{{ limitText(instrumentoVisualizadoResumo?.descricao || 'Selecione um instrumento de avaliação', 36) }}</span>
            <lucide-icon name="chevron-down" class="w-4 h-4 shrink-0"></lucide-icon>
          </button>

          <ul class="absolute left-0 right-0 mt-1 bg-white dark:bg-gray-800 rounded shadow-lg border border-gray-200 dark:border-gray-700 max-h-60 overflow-y-auto z-50"
            [class.hidden]="!showInstrumentoDropdown"
            aria-labelledby="instrumentoDropdown">
            <li *ngFor="let instrumento of instrumentosAvaliacaoParaSelecao; let i = index; trackBy: trackByInstrumentoResumo">
              <a
                href
                (click)="selecionarInstrumentoVisualizado(instrumento.id); $event.preventDefault()"
                class="flex items-center justify-between gap-3 px-3 py-2 text-sm transition-colors cursor-pointer"
                [class.bg-blue-600]="instrumentoVisualizadoResumo?.id === instrumento.id"
                [class.text-white]="instrumentoVisualizadoResumo?.id === instrumento.id"
                [class.font-semibold]="instrumentoVisualizadoResumo?.id === instrumento.id"
                [class.text-gray-700]="instrumentoVisualizadoResumo?.id !== instrumento.id"
                [class.dark:text-gray-200]="instrumentoVisualizadoResumo?.id !== instrumento.id"
                [class.hover:bg-blue-50]="instrumentoVisualizadoResumo?.id !== instrumento.id"
                [class.dark:hover:bg-gray-700]="instrumentoVisualizadoResumo?.id !== instrumento.id">
                <span>{{ instrumento.descricao }}</span>
                <lucide-icon *ngIf="instrumentoVisualizadoResumo?.id === instrumento.id" name="check" class="w-4 h-4 shrink-0"></lucide-icon>
              </a>
            </li>
          </ul>
        </div>

        <button
          type="button"
          (click)="selecionarProximoInstrumento()"
          [disabled]="!podeSelecionarProximoInstrumento"
          class="desempenho-mobile-nav__arrow"
          title="Próximo instrumento">
          <lucide-icon name="chevron-right" class="w-4 h-4"></lucide-icon>
        </button>
      </div>

      <div class="desempenho-mobile-toolbar mb-1">
        <div class="relative" data-dropdown-root>
          <button
            type="button"
            id="ordenacaoDropdown"
            (click)="toggleOrdenacaoDropdown()"
            class="desempenho-mobile-toolbar__icon"
            [title]="ordenacaoAtualTooltip">
            <lucide-icon [name]="ordenacaoAtualIcone" class="w-4 h-4"></lucide-icon>
          </button>

          <ul
            *ngIf="showOrdenacaoDropdown"
            class="absolute left-0 top-full z-50 mt-2 w-56 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800">
            <li>
              <button
                type="button"
                (click)="setOrdenacao('nomeAsc')"
                class="flex w-full items-center gap-3 px-4 py-3 text-left text-sm transition-colors"
                [ngClass]="ordenacaoAtual === 'nomeAsc' ? 'bg-blue-50 font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-200' : 'text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-700'">
                <lucide-icon name="arrow-down-a-z" class="h-4 w-4"></lucide-icon>
                <span>Ordem alfabética A-Z</span>
              </button>
            </li>
            <li>
              <button
                type="button"
                (click)="setOrdenacao('nomeDesc')"
                class="flex w-full items-center gap-3 px-4 py-3 text-left text-sm transition-colors"
                [ngClass]="ordenacaoAtual === 'nomeDesc' ? 'bg-blue-50 font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-200' : 'text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-700'">
                <lucide-icon name="arrow-up-z-a" class="h-4 w-4"></lucide-icon>
                <span>Ordem alfabética Z-A</span>
              </button>
            </li>
            <li>
              <button
                type="button"
                (click)="setOrdenacao('numeroChamadaAsc')"
                class="flex w-full items-center gap-3 px-4 py-3 text-left text-sm transition-colors"
                [ngClass]="ordenacaoAtual === 'numeroChamadaAsc' ? 'bg-blue-50 font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-200' : 'text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-700'">
                <lucide-icon name="arrow-down-0-1" class="h-4 w-4"></lucide-icon>
                <span>Nº da chamada crescente</span>
              </button>
            </li>
            <li>
              <button
                type="button"
                (click)="setOrdenacao('numeroChamadaDesc')"
                class="flex w-full items-center gap-3 px-4 py-3 text-left text-sm transition-colors"
                [ngClass]="ordenacaoAtual === 'numeroChamadaDesc' ? 'bg-blue-50 font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-200' : 'text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-700'">
                <lucide-icon name="arrow-down-1-0" class="h-4 w-4"></lucide-icon>
                <span>Nº da chamada decrescente</span>
              </button>
            </li>
          </ul>
        </div>

        <app-situacao-filter-dropdown
          [opcoes]="opcoesSituacaoEnturmacao"
          [valorSelecionado]="filtroSituacaoEnturmacao"
          placeholder="Situação"
          [maxVisivel]="8"
          (valorChange)="onSituacaoEnturmacaoChange($event)">
        </app-situacao-filter-dropdown>

        <div class="ml-auto flex items-center gap-2" *ngIf="porInstrumento && instrumentoVisualizadoResumo">
          <button
            type="button"
            (click)="editarInstrumento(instrumentoVisualizadoResumo)"
            class="desempenho-mobile-toolbar__icon"
            [disabled]="isEdicaoInstrumentoBloqueada(instrumentoVisualizadoResumo)"
            title="Editar instrumento">
            <lucide-icon name="edit-2" class="w-4 h-4"></lucide-icon>
          </button>

          <button
            type="button"
            (click)="togglePublicacaoInstrumento(instrumentoVisualizadoResumo)"
            class="relative flex h-10 w-10 items-center justify-center rounded-xl border transition-colors outline-none focus:ring-0 active:scale-95"
            [ngClass]="!!instrumentoVisualizadoResumo.publico 
              ? 'border-emerald-400 bg-emerald-100 text-emerald-700 dark:border-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300' 
              : 'border-gray-200 bg-white text-gray-500 hover:border-emerald-300 hover:text-emerald-600 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300'"
            [disabled]="instrumentoPublicandoId === instrumentoVisualizadoResumo.id || isPublicacaoInstrumentoBloqueada(instrumentoVisualizadoResumo)"
            [title]="instrumentoVisualizadoResumo.publico ? 'Desfazer publicação do desempenho' : 'Publicar desempenho'">
            
            <lucide-icon *ngIf="instrumentoPublicandoId !== instrumentoVisualizadoResumo.id" name="earth" class="h-5 w-5 shrink-0"></lucide-icon>
            <lucide-icon *ngIf="instrumentoPublicandoId === instrumentoVisualizadoResumo.id" name="loader-2" class="h-5 w-5 animate-spin"></lucide-icon>
            
            <span *ngIf="!!instrumentoVisualizadoResumo.publico && instrumentoPublicandoId !== instrumentoVisualizadoResumo.id"
                  class="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-emerald-500 text-white shadow">
              <lucide-icon name="check" class="h-3 w-3 shrink-0"></lucide-icon>
            </span>
          </button>
        </div>

        <div class="ml-auto flex items-center gap-1" *ngIf="!porInstrumento && colunas.length > 0">
          <button type="button" (click)="abrirModalDatasExames()" class="desempenho-mobile-toolbar__icon transition-colors" title="Datas de exames">
            <lucide-icon name="calendar" class="w-4 h-4 shrink-0"></lucide-icon>
          </button>
          
          <button type="button" (click)="abrirModalPublicacaoAnual()" class="desempenho-mobile-toolbar__icon transition-colors" title="Publicar notas">
            <lucide-icon name="earth" class="w-4 h-4 shrink-0"></lucide-icon>
          </button>
        </div>
      </div>

      </ng-container>
    </section>

    <!-- Conteúdo principal -->
    <div [class.opacity-60]="loadingTracker" [class.pointer-events-none]="loadingTracker">
    <!-- Tabela de desempenho por instrumento -->
      <div *ngIf="porInstrumento && !isTurmaEjaModular">
        <app-desempenho-instrumento
          [colunas]="colunasInstrumentoExibidas"
          [ocultarDetalhes]="ocultarDetalhes"
          [linhas]="linhasInstrumentoExibidas"
          [colunaMediaPeriodo]="colunaMediaPeriodo"
          [configuracaoAvaliacao]="configuracaoAvaliacao"
          [configuracaoCha]="configuracaoCha"
          [hasPermissionsToEdit]="true"
          [calculoFormula]="calculoFormula"
          [turma]="turma"
          [itemEducacional]="itemEducacional"
          [periodo]="periodo"
          [semCalendario]="semCalendario"
          [semPeriodoAvaliativo]="isSemPeriodoAvaliativo"
          [enumSituacaoMatricula]="enumSituacaoMatricula"
          [enumSituacaoDisciplina]="enumSituacaoDisciplina"
          [grupoEnturmacaoCor]="grupoEnturmacaoCor"
          [isLoading]="loadingTracker"
          [filtroAtivo]="!!filtroSituacaoEnturmacao || !!searchFilter.keywords"
          (salvar)="salvar($event)"
          (showParecer)="onShowParecer($event)"
          (togglePublicacao)="togglePublicacaoAvaliacao($event)"
          (showAvaliacaoDescritiva)="onShowAvaliacaoDescritiva($event)">
        </app-desempenho-instrumento>
    </div>

        <!-- Tabela de desempenho por ano -->
        <div *ngIf="!porInstrumento || isTurmaEjaModular">
          <app-desempenho-ano
            [componente]="itemEducacional"
            [colunas]="colunas"
            [linhas]="listaEnturmacoesOrdenada"
            [configuracaoAvaliacao]="configuracaoAvaliacao"
            [configuracaoCha]="configuracaoCha"
            [hasPermissionsToEdit]="true"
            [turma]="turma"
            [semCalendario]="semCalendario"
            [semPeriodoAvaliativo]="isSemPeriodoAvaliativo"
            [semDesempenhos]="semDesempenhos"
            [enumSituacaoMatricula]="enumSituacaoMatricula"
            [isLoading]="loadingTracker"
            [ocultarDetalhes]="ocultarDetalhes"
            (salvar)="salvar($event)"
            (showParecer)="onShowParecer($event)"
            (togglePublicacao)="togglePublicacaoAvaliacao($event)"
            (showAvaliacaoDescritiva)="onShowAvaliacaoDescritiva($event)"
            (showCHA)="onShowCHA($event)">
          </app-desempenho-ano>
        </div>
    </div>
  </div>

  <app-parecer-modal
    [aberto]="parecerModalAberto"
    [titulo]="parecerModalTitulo"
    [nomeAluno]="parecerModalNomeAluno"
    [carregando]="parecerModalCarregando"
    [salvando]="parecerModalSalvando"
    [texto]="parecerModalTexto"
    (textoChange)="parecerModalTexto = $event"
    (salvar)="salvarParecerModal()"
    (fechar)="fecharParecerModal()">
  </app-parecer-modal>

  <app-avaliacao-descritiva-modal
    [aberto]="avaliacaoDescritivaModalAberto"
    [titulo]="avaliacaoDescritivaModalTitulo"
    [nomeAluno]="avaliacaoDescritivaModalNomeAluno"
    [readonly]="avaliacaoDescritivaModalReadonly"
    [texto]="avaliacaoDescritivaModalTexto"
    (textoChange)="avaliacaoDescritivaModalTexto = $event"
    (salvar)="salvarAvaliacaoDescritivaModal()"
    (fechar)="fecharAvaliacaoDescritivaModal()">
  </app-avaliacao-descritiva-modal>

  <app-confirmacao-sim-nao
    [aberta]="avaliacaoConfirmacaoAberta"
    [titulo]="avaliacaoConfirmacaoTitulo"
    [carregando]="!!avaliacaoPublicandoId"
    (confirmar)="confirmarAcaoAvaliacao()"
    (cancelar)="fecharConfirmacaoAvaliacao()">
    <ng-container *ngIf="avaliacaoConfirmacaoPublicar">
      Os resultados e pareceres de
      <strong class="font-medium">{{ getRotuloAvaliacaoPublicacao(avaliacaoConfirmacaoNota) }}</strong>
      serão publicados para Pais e Alunos. Deseja continuar?
    </ng-container>
    <ng-container *ngIf="!avaliacaoConfirmacaoPublicar && getDataPublicacaoAvaliacao(avaliacaoConfirmacaoNota)">
      Os desempenhos de
      <strong class="font-medium">{{ getRotuloAvaliacaoPublicacao(avaliacaoConfirmacaoNota) }}</strong>
      foram publicados em
      <strong class="font-medium">{{ formatarDataHoraPublicacao(getDataPublicacaoAvaliacao(avaliacaoConfirmacaoNota) || '') }}</strong>.<br>
      Deseja desfazer a publicação?
    </ng-container>
    <ng-container *ngIf="!avaliacaoConfirmacaoPublicar && !getDataPublicacaoAvaliacao(avaliacaoConfirmacaoNota)">
      Os desempenhos de
      <strong class="font-medium">{{ getRotuloAvaliacaoPublicacao(avaliacaoConfirmacaoNota) }}</strong>
      serão despublicados.<br>
      Deseja desfazer a publicação?
    </ng-container>
  </app-confirmacao-sim-nao>

  <!-- Loader de salvamento -->
  <div *ngIf="saveTracker" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white dark:bg-gray-800 rounded-md p-6 text-center">
      <lucide-icon name="loader-2" class="w-8 h-8 animate-spin text-blue-600 dark:text-blue-400 mb-2"></lucide-icon>
      <p class="text-gray-700 dark:text-gray-200">Salvando...</p>
    </div>
  </div>

  <!-- Loader de carregamento -->
  <div *ngIf="loadingTracker" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white dark:bg-gray-800 rounded-md p-8 flex flex-col items-center shadow-lg max-w-md mx-4">
      <div class="mb-4">
        <div class="animate-spin rounded-full w-12 h-12 border-[3px] border-blue-500 border-t-transparent" role="status">
          <span class="sr-only">Carregando...</span>
        </div>
      </div>
      <h4 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">Carregando dados...</h4>
      <p class="text-sm text-gray-600 dark:text-gray-300 text-center">Aguarde enquanto buscamos as informações dos alunos e avaliações.</p>
    </div>
  </div>

  <!-- Modal de erro -->
  <div *ngIf="showErrorModal" 
       class="error-modal-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]" 
       (click)="closeErrorModal()">
    <div class="error-modal-content bg-white dark:bg-gray-800 rounded-md shadow-xl max-w-md mx-4 w-full animate-fade-in"
         (click)="$event.stopPropagation()">
      <!-- Cabeçalho -->
      <div class="bg-red-50 dark:bg-red-900 border-b border-red-200 dark:border-red-700 rounded-t-md px-6 py-4 flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div class="bg-red-100 dark:bg-red-800 rounded-full p-2 flex-shrink-0">
            <lucide-icon name="alert-triangle" class="w-6 h-6 text-red-600 dark:text-red-300"></lucide-icon>
          </div>
          <h3 class="text-lg font-semibold text-red-900 dark:text-red-100">Erro ao salvar</h3>
        </div>
        <button 
          type="button"
          (click)="closeErrorModal()"
          class="text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700"
          aria-label="Fechar">
          <lucide-icon name="x" class="w-6 h-6"></lucide-icon>
        </button>
      </div>
      
      <!-- Corpo -->
      <div class="px-6 py-5">
        <p class="text-gray-700 dark:text-gray-200 text-base leading-relaxed whitespace-pre-wrap break-words">{{errorMessage}}</p>
      </div>
      
      <!-- Rodapé -->
      <div class="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 rounded-b-md px-6 py-4 flex justify-end">
        <button
          type="button"
          (click)="closeErrorModal()"
          class="px-6 py-2.5 bg-red-600 dark:bg-red-600 text-white rounded-md font-medium hover:bg-red-700 dark:hover:bg-red-700 transition-all focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 active:scale-95">
          Entendi
        </button>
      </div>
    </div>
  </div>

  <app-instrumento-avaliacao-modal #instrumentoModalRef [vm]="vm"></app-instrumento-avaliacao-modal>
  
  <app-publicacao-anual-modal 
  [isOpen]="publicacaoAnualModalAberta" 
  [colunas]="colunas" 
  [linhas]="linhas"
  [turmaId]="turma?.id || null"
  [colunaMedia]="colunaMediaPeriodo"
  (togglePublicacao)="togglePublicacaoAvaliacao($event)"
  (fechado)="publicacaoAnualModalAberta = false">
</app-publicacao-anual-modal>

<app-data-exames-conselho-modal 
  [isOpen]="dataExamesModalAberta" 
  [colunas]="colunas" 
  [linhas]="linhas"
  [turmaId]="turma?.id || null"
  [itemEducacionalId]="itemEducacional?.id || null"
  (fechado)="dataExamesModalAberta = false">
</app-data-exames-conselho-modal>
</div>
